import {formatWithCommas} from './formatWithCommas';

export function formatWithCommasAndDefaultHyphen(
  value?: any,
  supplier?: (firstParam: any) => number
): string {
  if (value === undefined) {
    return '-';
  }

  if (typeof value === 'number') {
    return formatWithCommas(value);
  }
  if (typeof value === 'string') {
    if (isNaN(Number(value))) {
      return '-';
    }
    return formatWithCommas(Number(value));
  }
  if (supplier === undefined) {
    return '-';
  }
  return formatWithCommas(supplier(value));
}
